export const validateBusinessEmail = (email: string): Promise<boolean> => {
  const emailDomain = email.split('@')[1] ?? ''

  return import('./validateBusinessEmail.consts').then(
    ({ freeEmailDomains }) => !freeEmailDomains.includes(emailDomain),
  )
}
